import dayjs from "dayjs";

import { useMediaQuery, useTheme } from "@mui/material";

import { tonsToLbs, tonsToKgs } from "@aclymatepackages/converters";

export const generateRandomPin = () =>
  Math.floor(100000 + Math.random() * 900000);

export const isObjectEmpty = (obj) => {
  if (!obj || typeof obj !== "object") {
    return true;
  }
  return !Object.keys(obj).length;
};

export const generateTempId = () => dayjs().unix() * Math.random();

export const generateSecureId = () => crypto.randomUUID();

export const useLayoutHelpers = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isMedium = useMediaQuery(theme.breakpoints.down("lg"));

  const standardBoxPadding = {
    px: isMobile ? 1 : isMedium ? 2 : 8,
    py: isMobile ? 5 : 8,
  };

  return { theme, isMobile, isMedium, standardBoxPadding };
};

export const sortOptionsAlphabetically = (options = [], key = "name") => {
  if (!options?.length) {
    return [];
  }

  return [...options].sort((a, b) => {
    if (a[key] < b[key]) {
      return -1;
    }
    if (b[key] < a[key]) {
      return 1;
    }
    return 0;
  });
};

export const carbonUnitTypes = [
  {
    name: "Pounds",
    short: "lbs",
    converter: (tons) => (tons ? tonsToLbs(tons) : 0),
  },
  {
    name: "Kilograms",
    short: "kgs",
    converter: (tons) => (tons ? tonsToKgs(tons) : 0),
  },
  { name: "Tonnes", short: "tons", converter: (tons) => tons },
];

export const convertDataToCsv = (formattedRows, header) => {
  const csvRows = formattedRows
    .map(
      (row) =>
        Object.values(row)
          .map((string) => (string ? `"${string}"` : ""))
          .join(",") + "\r\n"
    )
    .join("");

  return new Blob([`${header}\r\n${csvRows}`], { type: "text/csv" });
};

export const getUrlSearchParams = (param) =>
  new URLSearchParams(window.location.search).get(param);
